export const facebookLikeBoxMetaData = {
    isRepeatable: false
}
